/**
 * 品牌支付配置入口
 */
import type { BrandPaymentConfig, ChapterConfig, PayPageConfig, SubscribePageConfig } from '../types'
import { vowpathPaymentConfig } from './vowpath'

export { vowpathPaymentConfig } from './vowpath'

/**
 * 获取当前品牌的完整支付配置
 */
export function getPaymentConfig(): BrandPaymentConfig {
  return vowpathPaymentConfig
}

/**
 * 获取当前品牌的充值页面配置
 */
export function getPayPageConfig(): PayPageConfig {
  return getPaymentConfig().pay
}

/**
 * 获取当前品牌的订阅页面配置
 */
export function getSubscribePageConfig(): SubscribePageConfig {
  return getPaymentConfig().subscribe
}

/**
 * 获取当前品牌的阅读器弹窗配置
 */
export function getChapterConfig(): ChapterConfig {
  return getPaymentConfig().chapter
}

/**
 * 按场景加载配置的辅助函数
 */
export function loadPaymentConfigByScene<T extends 'pay' | 'subscribe' | 'chapter'>(
  scene: T,
): T extends 'pay' ? PayPageConfig : T extends 'subscribe' ? SubscribePageConfig : ChapterConfig {
  const config = getPaymentConfig()
  return config[scene] as any
}
